import algoliasearch from 'algoliasearch';
import apiKeys from '@/../api-keys';

const client: algoliasearch.Client = algoliasearch(
  apiKeys.ALGOLIA_APP_ID,
  apiKeys.ALGOLIA_SEARCH_KEY,
);
const index = client.initIndex('transcription');
index.setSettings({
  attributesToSnippet: ['text:80'],
  hitsPerPage: 10,
});

export default index;
